import React, { useState } from "react";
import { SidePopupContainer, FlexColumn, AppSpan, Button, FlexRow, Form, FormGroup } from "src/style";
import { RiCloseFill } from "react-icons/ri";

export const PasswordChange: React.FC<any> = ({close}) => {
    const [input, setInput] = useState({oldPassword: '', newPassword: '', confirmPassword: ''})

    const handleInput = (e: React.ChangeEvent<HTMLInputElement|HTMLSelectElement>) => setInput({...input, [e.target.name]: e.target.value})

    async function handleSubmit (e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()

        close()
    }
    return (
        <>
            <SidePopupContainer zIndex="8" onClick={close} />
            <FlexColumn
                className="center-popup-container"
                justifyContent="flex-start"
                alignItems="flex-start" 
            >
                <FlexRow justifyContent='space-between' gap='2'>
                    <AppSpan color='#101828' textSize='1.8' fontWeight="600">Change Password</AppSpan>
                    <Button 
                        titleSize="2" fontWeight="500"
                        width='3.4' shadow='none'
                        height='3.4'
                        radius='0.4'
                        bgColor='#ffffff'
                        hoverBgColor='#FEF3F2'
                        borderColor='none'
                        color='#000000'
                        hoverColor='#B42318'
                        onClick={close}
                    >
                        <RiCloseFill style={{fontSize: '2.3rem'}} />
                    </Button> 
                </FlexRow>
                <Form onSubmit={handleSubmit} topMargin='2'>
                    <FormGroup>
                        <label>Old Password</label>
                        <input 
                            placeholder="Enter old password" 
                            name='oldPassword'
                            type='password'
                            value={input.oldPassword}
                            onChange={handleInput}
                            required
                        />
                    </FormGroup> 
                    <FormGroup>
                        <label>New Password</label>
                        <input 
                            placeholder="Enter new password" 
                            name='newPassword'
                            type='password'
                            value={input.newPassword}
                            onChange={handleInput}
                            required
                        />
                    </FormGroup> 
                    <FormGroup>
                        <label>Confirm Password</label>
                        <input 
                            placeholder="Confirm new password" 
                            name='confirmPassword'
                            type='password'
                            value={input.confirmPassword}
                            onChange={handleInput}
                            required
                        />
                    </FormGroup> 

                    <FlexRow justifyContent='flex-end'>
                        <Button
                            width='12.9'
                            titleSize='1.4' fontWeight="500"
                            height='4' radius='0.8'
                            bottomMargin='1' hoverColor='#0D968F'
                            hoverBgColor='#fff' borderColor='#0D968F'
                        >
                            Submit
                        </Button>
                    </FlexRow>
                </Form>
            </FlexColumn>
        </>
    )
}